<div class="scroll-wrapper">
    <div>
        <ng-content></ng-content>
    </div>

    <div
        class="custom-scrollbar-track"
        [ngClass]="scrollbarClass"
        [ngStyle]="{
            '--track-width-mobile': mobileTrackWidth,
            '--track-width-desktop': desktopTrackWidth
        }"
    >
        <div class="custom-scrollbar-thumb" [ngClass]="scrollbarClass"></div>
    </div>
</div>
